<template>
  <div class="x-tel-input">
    <label v-if="label">
      {{ label }}
    </label>

    <VueTelInput
      :value="tel"
      placeholder=""
      v-bind="$attrs"
      :class="{ 'error': error }"
      @input="onChange"
    />
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input'

export default {
  name: 'XTelInput',

  components: {
    VueTelInput
  },

  inheritAttrs: false,

  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: null
    },
    error: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    tel () {
      return this.value || ''
    }
  },

  methods: {
    onChange (value, obj) {
      this.$emit('input', value)

      // When phone number is not required, empty value is a valid state
      const valid = this.required ? obj.valid : (obj.valid || value.length === 0)
      this.$emit('valid', valid)
    }
  }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
@import '~@/styles/vars.scss';

.x-tel-input {
  width: 100%;
  min-height: 4.6rem;
  padding: 1.6rem 0;
  display: flex;
  position: relative;
  font-family: inherit;

  label {
    top: -0.3rem;
    position: absolute;
    font-size: 1.2rem;
    text-transform: uppercase;
    opacity: 1;
    left: 1.4rem;
    font-weight: 600;
    color: $color-silver;
  }

  .vue-tel-input {
    border: 0.1rem solid $color-ghost;
    border-radius: 0.4rem;
    width: 100%;

    /deep/ input {
      padding: 0.6rem 1.4rem;
      line-height: 3.2rem;
      color: $color-raven;
      font-family: inherit;
      font-size: 1.6rem;
      font-weight: 600;
      background: none;

      &[disabled] {
        background-color: #f5f6fa;
      }
    }

    &:active, &:focus, &:focus-within {
      border-color: map_get($palette-primary, main);
      outline: none!important;
      box-shadow: none;
    }

    /deep/ .vti__dropdown {
      outline: none;
      box-shadow: none;
    }

    &.disabled {
      background-color: #f5f6fa;
      border: none;
    }

    &.error {
      border-color: $color-error;
    }

    /deep/  .vti__dropdown-list {
      z-index: $z-index-2;
    }
  }
}
</style>